import { Injectable, inject } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { resolveUrl, API_PREFIX } from 'src/core/constants/api.constants';
import { FreeSwitchInstanceDto } from '../models/free-switch-instance.dto';
import { ExecuteFreeSwitchConsoleCommandInput } from '../models/execute-free-switch-console-command-input.dto';
import { FreeSwitchConsoleCommandResultDto } from '../models/free-switch-console-command-result.dto';

const FS_INSTANCE = `${API_PREFIX}/free-switch-instance`;

@Injectable({ providedIn: 'root' })
export class FreeSwitchInstanceService {
  private readonly http = inject(HttpClient);

  getByTenant(tenantId: string): Observable<FreeSwitchInstanceDto | null> {
    return this.http.get<FreeSwitchInstanceDto | null>(resolveUrl(`${FS_INSTANCE}/by-tenant/${tenantId}`));
  }

  activate(id: string): Observable<void> {
    return this.http.post<void>(resolveUrl(`${FS_INSTANCE}/${id}/activate`), {});
  }

  deactivate(id: string): Observable<void> {
    return this.http.post<void>(resolveUrl(`${FS_INSTANCE}/${id}/deactivate`), {});
  }

  executeConsoleCommand(
    id: string,
    input: ExecuteFreeSwitchConsoleCommandInput,
  ): Observable<FreeSwitchConsoleCommandResultDto> {
    return this.http.post<FreeSwitchConsoleCommandResultDto>(
      resolveUrl(`${FS_INSTANCE}/${id}/execute-console-command`),
      input,
    );
  }

  checkWebRtcHostUnique(webRtcHost: string, excludeId?: string): Observable<boolean> {
    let params = new HttpParams().set('maxResultCount', '1000');
    if (excludeId) {
      params = params.set('excludeId', excludeId);
    }
    return this.http
      .get<{ items: FreeSwitchInstanceDto[] }>(resolveUrl(FS_INSTANCE), { params })
      .pipe(
        map(result => {
          const items = result?.items ?? [];
          return !items.some(
            item =>
              item.webRtcHost &&
              item.webRtcHost.trim().toLowerCase() === webRtcHost.trim().toLowerCase() &&
              item.id !== excludeId,
          );
        }),
      );
  }
}
